import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {}

// vuetify breaks ionics padding, this fixes it
function removeAsteriksRules() {
  const styles = document.querySelectorAll('style')

  styles.forEach(style => {
    const sheet = style.sheet ? style.sheet : style.styleSheet;

    removeAsteriksRulesFromSheet(sheet)
  })

  document.styleSheets.forEach(sheet => removeAsteriksRulesFromSheet(sheet))

  // this rule was also removed, but we actually need this one, so we add it back here.
  document.styleSheets[0].insertRule("* { box-sizing: border-box; -webkit-tap-highlight-color: transparent; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; }")
}

function removeAsteriksRulesFromSheet(sheet) {
  if(!sheet.cssRules) {
    return
  }

  for (let i = 0; i < sheet.cssRules.length; i++) {
    const selector = sheet.cssRules[i].selectorText
    
    if (selector && selector.indexOf('*') !== -1) {        
      // console.log(sheet.cssRules[i]);
      sheet.deleteRule(i);
    }
  }  
}

removeAsteriksRules()

export default new Vuetify(opts)